import { convertHeader2024, convertLegacyHeader } from 'components/Header/data';

const convertLegacyBody = (data) => ({
  title: data.title,
  metaTitle: data.metaTitle,
  requestUrl: data.requestUrl,
  baseUrl: data.baseUrl,
  blocks: data.blocks,
  ...data,
});

export const convertLegacyModel = ({
  header,
  body,
  footer,
  settings: { common: settings, ...common },
}) => ({
  header: convertLegacyHeader(header),
  specialProjectHeader: convertHeader2024(header, common?.meta),
  body: convertLegacyBody(body),
  footer,
  common: {
    ...common,
    settings: {
      lastKnownResolutionCookieName: 'lastKnownResolution',
      ...settings,
      lastKnownResolution: settings.lastKnownResolution ? Number(settings.lastKnownResolution) : '',
    },
  },
  settings: common,
});
